import { render, staticRenderFns } from "./ServiceListComponent.vue?vue&type=template&id=5d496320&scoped=true"
import script from "./ServiceListComponent.vue?vue&type=script&lang=js"
export * from "./ServiceListComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiceListComponent.vue?vue&type=style&index=0&id=5d496320&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d496320",
  null
  
)

export default component.exports